import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import "./assets/b24"

Vue.config.productionTip = false
Vue.prototype.$BX24 = window.BX24

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
